export const getDashboardBaseUrl = () => {
  return '';
};

export const getDashboardHomeUrl = () => `${getDashboardBaseUrl()}/dash/home`;
